import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from '@ps_main/store_auth'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

const appStore = new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
  },
  strict: process.env.DEV,
})

export default appStore
